import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { Button, Form } from 'antd';
import { TabContentWrapper } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import ManifestationRecipientForm from '@/components/Fiscal/ManifestationRecipient/ManifestationRecipientForm';
import {
  ManifestationRecipientInvoice,
  RecipientInvoiceFormValues,
} from '@/core/domain/invoice/recipientInvoice/recipientInvoice.types';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useDisclosure } from '@/hooks';
import { useState } from 'react';
import RecipientInvoiceSearchModal from '@/components/Fiscal/ManifestationRecipient/RecipientInvoiceSearchModal';
import ManifestationRecipientList from '@/components/Fiscal/ManifestationRecipient/ManifestationRecipientList';
import ManifestSelectedItemsModal from '@/components/Fiscal/ManifestationRecipient/RecipientManifestationItemsModal';

const ManifestationRecipientPage = ({ route }: PageProps) => {
  const intl = useIntl();
  const [form] = Form.useForm<RecipientInvoiceFormValues>();
  const [modalDesignatedNotesOpened, modalDesignatedNotesAction] =
    useDisclosure();
  const [modalManifestSelectedItemsOpened, modalManifestSelectedItemsAction] =
    useDisclosure();

  const formValues = Form.useWatch([], form);

  const [manifestationItems, setManifestationItems] = useState<
    ManifestationRecipientInvoice[]
  >([]);

  return (
    <>
      <TabContentWrapper
        title={route.name}
        permissions={route.permissions}
        extra={
          <SpaceForButton>
            <Button
              block
              type="primary"
              disabled={!manifestationItems.length && !!formValues?.companyId}
              onClick={modalManifestSelectedItemsAction.open}
            >
              Manifestar notas selecionadas
            </Button>

            <Button
              block
              type="primary"
              onClick={modalDesignatedNotesAction.open}
            >
              Pesquisar notas a manifestar
            </Button>
          </SpaceForButton>
        }
      >
        <Helmet
          title={intl.formatMessage({
            id: 'invoice.manifestationRecipient.helmet.title',
          })}
        />

        <ManifestationRecipientForm form={form} />

        <ManifestationRecipientList
          formValues={formValues}
          manifestationItems={manifestationItems}
          setManifestationItems={setManifestationItems}
        />
      </TabContentWrapper>

      <RecipientInvoiceSearchModal
        open={modalDesignatedNotesOpened}
        onCancel={modalDesignatedNotesAction.close}
      />

      <ManifestSelectedItemsModal
        companyId={formValues?.companyId}
        manifestationItems={manifestationItems}
        open={modalManifestSelectedItemsOpened}
        onCancel={modalManifestSelectedItemsAction.close}
      />
    </>
  );
};

export default ManifestationRecipientPage;
